
import MoneyTick from "../../../assets/duotone/MoneyTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyTickIcon({ className, dataTestid = "MoneyTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
